import { Component } from '@angular/core';

import { InvoiceService } from 'src/app/services/invoice/invoice.service';
import { TransactionService } from 'src/app/services/transaction/transaction.service';
import { LocationService } from 'src/app/services/location/location.service';
import { InvoicingService } from 'src/app/services/invoicing/invoicing.service';

import { TransactionStatus } from 'src/app/models/transaction.interface';
import {
  PaymentCardTypeId,
  PaymentTypeId
} from 'src/app/models/transaction-enums.model';

@Component({
  selector: 'app-view',
  templateUrl: './view.component.html',
  styleUrls: ['./view.component.scss']
})
export class InvoiceViewComponent {
  paymentCardTypeId = PaymentCardTypeId;
  paymentTypeId = PaymentTypeId;

  public invoiceService: InvoiceService;
  public invoicingService: InvoicingService;
  public transactionService: TransactionService;
  public locationService: LocationService;

  public transactionStatusItems: TransactionStatus | undefined;

  constructor(
    invoiceService: InvoiceService,
    transactionService: TransactionService,
    locationService: LocationService,
    invoicingService: InvoicingService
  ) {
    this.locationService = locationService;
    this.transactionService = transactionService;
    this.invoiceService = invoiceService;
    this.invoicingService = invoicingService;
  }
}
